import 'moment-timezone';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import React, { memo, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive';
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";

const DataTableCustomer = ({ onCallback }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [customers, setCustomers] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const loadLazyData = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/customer?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}`, { //
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
                // pragma: 'no-cache',
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setTotalRecords(json.results.total);
                setCustomers(json.results.data);
            }
            setLoading(false);
        });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        return () => loadLazyData();
    }, [lazyParams]);

    useEffect(() => {
        //Clear the previous timeout.
        clearTimeout(timeout.current);

        // If there is no search term, do not make API call
        if (!globalFilterValue.trim()) {
            loadLazyData()
            return
        }
        timeout.current = setTimeout(() => {
            loadLazyData();
        }, 600);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setCustomers([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const header = (
        <Row>
            <Col md={12} className="my-2">
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText ref={inputRef} className="p-inputtext-lg" onChange={onGlobalFilterChange} placeholder="Pencarian..." style={{ minWidth: '100%' }} />
                </div>
            </Col>
        </Row>
    );

    const mobileTemplate = (value) => {
        return <div className="mb-3">
            <div className="mt-2">
                <small className="text-muted" style={{ fontSize: '12px' }}>ID PELANGGAN</small><br />
                <span className="fw-bold">{value.id}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>NAMA PELANGGAN</small><br />
                <span className="fw-bold">{value.name}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>EMAIL</small><br />
                <span className="fw-medium">{value.email}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>NO HANDPHONE</small><br />
                <span className="fw-medium">{value.phone}</span><br />
                <small className="text-muted" style={{ fontSize: '12px' }}>ALAMAT</small><br />
                <span className="fw-normal fst-italic">{value.address}</span><br />
            </div>
        </div>;
    }

    return (
        <Container className="mt-3">
            <DataTable
                value={customers}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['judul', 'deskripsi']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selectionMode="single"
                onSelectionChange={(e) => { onCallback(e.value) }}>
                {isTabletOrLaptop && <Column field="id" header="ID" />}
                {isTabletOrLaptop && <Column field="name" header="NAMA" />}
                {isTabletOrLaptop && <Column field="email" header="EMAIL" />}
                {isTabletOrLaptop && <Column field="phone" header="NO HANDPHONE" />}
                {isTabletOrLaptop && <Column field="address" header="ALAMAT" />}
                {isMobile && <Column body={mobileTemplate} />}
            </DataTable>
        </Container>
    );
}

export default memo(DataTableCustomer);
